import React, { useEffect, useState } from "react";
import { Container, Typography, Box, CircularProgress } from "@mui/material";
import ReactMarkdown from "react-markdown";

const TermsAndConditionsPage = () => {
  const [termsText, setTermsText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetch("/terms_and_conditions.md")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load terms and conditions.");
        return res.text();
      })
      .then((text) => {
        setTermsText(text);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to load terms and conditions.");
        setLoading(false);
      });
  }, []);

  return (
    <Container maxWidth="md" sx={{ mt: 6, mb: 6, fontFamily: 'Roboto, Arial, sans-serif' }}>
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography variant="h4" fontWeight="bold" color="#492099" gutterBottom>
          Terms and Conditions
        </Typography>
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <Box sx={{ fontFamily: 'Roboto, Arial, sans-serif' }}>
          <ReactMarkdown>{termsText}</ReactMarkdown>
        </Box>
      )}
    </Container>
  );
};

export default TermsAndConditionsPage;
